import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2560f8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-tetrapak" }

import { ref, computed, nextTick, provide, Ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Navbar from './components/navbar.vue';
import PageMain from './components/page-main.vue';
import PageJoin from './components/page-join.vue';
import PageAbout from './components/page-about.vue';
import PageAboutRecycling from './components/page-about-recycling.vue';
import PageFaq from './components/page-faq.vue';
import PageMap from './components/page-map.vue';
import { useElementVisibility, useScroll } from '@vueuse/core';
import _ from 'lodash';

interface MenuType {
  name: string;
  mobileName?: string;
  key?: 'main' | 'mission' | 'date' | 'method' | 'faq';
  pageRef?: Ref<HTMLDivElement | undefined>;
  anchor?: string;
  onClick?: () => Promise<void>;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pageMainRef = ref<HTMLDivElement>();
const pageJoinRef = ref<HTMLDivElement>();
const pageMapRef = ref<HTMLDivElement>();
const pageAboutRef = ref<HTMLDivElement>();
const pageAboutRecyclingRef = ref<HTMLDivElement>();
const pageFaqRef = ref<HTMLDivElement>();

function checkWebPSupport(): Promise<boolean> {
  return new Promise((resolve) => {
    const image = new Image();
    image.addEventListener('error', () => resolve(false));
    image.addEventListener('load', () => resolve(image.width > 0 && image.height > 0));
    image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
  });
}

const supportWebp = ref<boolean | undefined>();
const pageInited = ref(false);
checkWebPSupport()
  .then(support => supportWebp.value = support)
  .catch(() => supportWebp.value = false)
  .finally(() => nextTick(() => {
    pageInited.value = true;
    setTimeout(scrollToAnchorPosition, 300);
  }));

let isScrollingProgrammatically = false;
const activeMenuIndex = ref(0);
const menus = computed<Array<MenuType>>(() => {
  return [
    {
      name: 'HOME',
      key: 'main',
      pageRef: pageMainRef,
      anchor: '#page-main',
    },
    {
      name: '参加方法',
      key: 'join',
      pageRef: pageJoinRef,
      anchor: '#page-join',
    },
    {
      name: '対象店舗',
      key: 'map',
      pageRef: pageMapRef,
      anchor: '#page-map',
    },
    {
      name: 'テトラパックについて',
      mobileName: 'テトラパック\nについて',
      key: 'about',
      pageRef: pageAboutRef,
      anchor: '#page-about',
    },
    {
      name: 'リサイクルについて',
      mobileName: 'リサイクル\nについて',
      pageRef: pageAboutRecyclingRef,
      key: 'page-about-recycling',
      anchor: '#page-about-recycling',
    },
    {
      name: 'FAQ',
      pageRef: pageFaqRef,
      key: 'faq',
      anchor: '#page-faq',
    },
  ].filter(Boolean) as Array<MenuType>;
});
const navbarIsVisible = ref(false);

const pageVisibles = menus.value.filter(item => item.pageRef).map(item => useElementVisibility(item.pageRef));
const { directions } = useScroll(window, {
  onScroll() {
    if (isScrollingProgrammatically) {
      return;
    }
    if (directions.bottom) {
      activeMenuIndex.value = _.findLastIndex(pageVisibles, item => item.value);
    }
    if (directions.top) {
      activeMenuIndex.value = _.findIndex(pageVisibles, item => item.value);
    }
  },
  onStop() {
    isScrollingProgrammatically = false;
  },
});
function navToPage(item: typeof menus.value[number]) {
  if (item.onClick) {
    item.onClick();
    return;
  }
  if (item.pageRef) {
    isScrollingProgrammatically = true;
    item.pageRef?.value?.scrollIntoView({ block: 'start' });
    activeMenuIndex.value = menus.value.findIndex(i => i.name === item.name);
  }
}

function navToPageByKey(key: MenuType['key']) {
  const item = menus.value.find(item => item.key === key);
  if (item) {
    navToPage(item);
  }
}
provide('navToPageByKey', navToPageByKey);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const router = useRouter();
function onMenuItemClick(item: typeof menus.value[number]) {
  navToPage(item);
  // 客户应该是想要点按钮不加锚点，自己输入链接带上锚点
  // if (item.anchor) {
  //   // 用锚点在有的手机有些奇怪的问题
  //   router.push({ hash: item.anchor });
  // }
}

const route = useRoute();
function scrollToAnchorPosition() {
  const key = route.hash.split('#page-').pop();
  if (key) {
    navToPageByKey(key as any);
  }
}

// https://fonts.adobe.com/fonts/hiragino-kaku-gothic-pron#fonts-section
function loadTypekit() {
  const config = {
    kitId: 'ckt5zpr',
    scriptTimeout: 3000,
    async: true
  };
  const d = document;
  const h = d.documentElement;
  // 设置超时
  const t = setTimeout(() => {
    h.className = h.className.replace(/\bwf-loading\b/g, '') + ' wf-inactive';
  }, config.scriptTimeout);
  // 创建script标签
  const tk: any = d.createElement('script');
  let f = false;
  const s = d.getElementsByTagName('script')[0];
  h.className += ' wf-loading';
  tk.src = 'https://use.typekit.net/' + config.kitId + '.js';
  tk.async = true;
  // 处理加载事件
  tk.onload = tk.onreadystatechange = function() {
    const a = this.readyState;
    if (f || (a && a !== 'complete' && a !== 'loaded')) {
      return;
    }
    f = true;
    clearTimeout(t);
    try {
      window.Typekit.load(config);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to load Typekit:', e);
    }
  };
  // 插入script标签
  s.parentNode?.insertBefore(tk, s);
}

onMounted(() => {
  loadTypekit();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "navbar-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(Navbar, {
          sticky: "",
          "active-menu-index": activeMenuIndex.value,
          menus: _unref(menus),
          onMenuClick: onMenuItemClick
        }, null, 8, ["active-menu-index", "menus"]), [
          [_vShow, !navbarIsVisible.value]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      id: "page-main",
      ref_key: "pageMainRef",
      ref: pageMainRef
    }, [
      _createVNode(PageMain, {
        modelValue: navbarIsVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((navbarIsVisible).value = $event)),
        "active-menu-index": activeMenuIndex.value,
        menus: _unref(menus),
        onMenuClick: onMenuItemClick
      }, null, 8, ["modelValue", "active-menu-index", "menus"])
    ], 512),
    _createElementVNode("div", {
      id: "page-join",
      ref_key: "pageJoinRef",
      ref: pageJoinRef
    }, [
      _createVNode(PageJoin)
    ], 512),
    _createElementVNode("div", {
      id: "page-map",
      ref_key: "pageMapRef",
      ref: pageMapRef
    }, [
      _createVNode(PageMap)
    ], 512),
    _createElementVNode("div", {
      id: "page-about",
      ref_key: "pageAboutRef",
      ref: pageAboutRef
    }, [
      _createVNode(PageAbout)
    ], 512),
    _createElementVNode("div", {
      id: "page-about-recycling",
      ref_key: "pageAboutRecyclingRef",
      ref: pageAboutRecyclingRef
    }, [
      _createVNode(PageAboutRecycling)
    ], 512),
    _createElementVNode("div", {
      id: "page-faq",
      ref_key: "pageFaqRef",
      ref: pageFaqRef
    }, [
      _createVNode(PageFaq)
    ], 512)
  ]))
}
}

})